import { Row, theme } from 'antd';
import CustomDivider from '../../../../components/CustomDivider';
import TicketReportFiltersContainer from './TicketReportFiltersContainer';
import TicketReportItemsContainer from './TicketReportItemsContainer';

const TicketReportContainer = () => {
    const {
        token: { colorBgLayout, paddingMD }
    } = theme.useToken();

    return (
        <>
            <Row
                style={{
                    backgroundColor: colorBgLayout,
                    paddingTop: paddingMD
                }}
            >
                <TicketReportFiltersContainer />
            </Row>
            <CustomDivider />
            <TicketReportItemsContainer />
        </>
    );
};

export default TicketReportContainer;
